// QA check with HW

import {UserDetailsMinRes} from '../cp';
import {Type} from 'class-transformer';

export class DeviceDataMinRes{
    public readonly guid!: string;
    @Type(() => UserDetailsMinRes)
    machineUser!: UserDetailsMinRes
    machineHostName!: string;
    cpuArchitecture!: string;
    machineUniqueId!: string;
    kernelType!:string;
    kernelVersion!:string;
}

export class DeviceDataRes {
    public readonly guid!: string;
    public readonly createdAt!: Date;
    public readonly updatedAt!: Date;
    @Type(() => UserDetailsMinRes)
    public readonly createdBy: UserDetailsMinRes = new UserDetailsMinRes();
    @Type(() => UserDetailsMinRes)
    public readonly updatedBy: UserDetailsMinRes = new UserDetailsMinRes();
    public machineUniqueId!: string;
    public machineHostName!: string;
    public cpuArchitecture!: string;
    public kernelType!: string;
    public kernelVersion!: string;
    public prettyProductName!: string;
    public productType!: string;
    public productVersion!: string;
    public installationDate!: Date;
    public active!: boolean;
    @Type(() => UserDetailsMinRes)
    public machineUser: UserDetailsMinRes | null = null;
    public ipV6!: string;
    public ipV4!: string;
    public note!: string;

    public clone(response: DeviceDataRes): DeviceDataRes {
        let responseClone = new DeviceDataRes();

        responseClone.machineUniqueId = response.machineUniqueId;
        responseClone.machineHostName = response.machineHostName;
        responseClone.cpuArchitecture = response.cpuArchitecture;
        responseClone.kernelType = response.kernelType;
        responseClone.kernelVersion = response.kernelVersion;
        responseClone.prettyProductName = response.prettyProductName;
        responseClone.productType = response.productType;
        responseClone.productVersion = response.productVersion;
        responseClone.installationDate = response.installationDate;
        responseClone.active = response.active;
        responseClone.machineUser = response.machineUser;
        responseClone.ipV6 = response.ipV6;
        responseClone.ipV4 = response.ipV4;
        responseClone.note = response.note;

        return responseClone;
    }
}

export class DeviceDataUReq{
    public machineUniqueId?: string;
    public machineHostName?: string;
    public cpuArchitecture?: string;
    public kernelType?: string;
    public kernelVersion?: string;
    public prettyProductName?: string;
    public productType?: string;
    public productVersion?: string;
    public installationDate?: Date;
    public active?: boolean;
    public machineUser?: number;
    public ipV6?: string;
    public ipV4?: string;
    public note?: string;

    constructor(value: Partial<DeviceDataUReq>) {
        Object.assign(this, value);
    }
}

export class DeviceDataRequest {
    public machineUniqueId?: string;
    public machineHostName?: string;
    public cpuArchitecture?: string;
    public kernelType?: string;
    public kernelVersion?: string;
    public prettyProductName?: string;
    public productType?: string;
    public productVersion?: string;
    public installationDate?: Date;
    public active?: boolean;
    public machineUser?: number;
    public ipV6?: string;
    public ipV4?: string;
    public note?: string;

    constructor(value: Partial<DeviceDataRequest>) {
        Object.assign(this, value);
    }

    public fromResponse(response: DeviceDataRes): DeviceDataRequest {
        let request = new DeviceDataRequest({});
        request.machineUniqueId = response.machineUniqueId;
        request.machineHostName = response.machineHostName;
        request.cpuArchitecture = response.cpuArchitecture;
        request.kernelType = response.kernelType;
        request.kernelVersion = response.kernelVersion;
        request.prettyProductName = response.prettyProductName;
        request.productType = response.productType;
        request.productVersion = response.productVersion;
        request.installationDate = response.installationDate;
        request.active = response.active;
        request.machineUser = response.machineUser?.id;
        request.ipV6 = response.ipV6;
        request.ipV4 = response.ipV4;
        request.note = response.note;

        return request;
    }
}

export class DeviceDataCsvImportRequest {
    mappingId!: number;
    data!: any[];

    constructor(mappingId: number, data: any[]) {
        this.mappingId = mappingId;
        this.data = data;
    }
}
